import { config } from '~/shared/config'
import { styles } from './styles'

// Sha provides component for displaying git commit sha and link to it
export function Sha(): JSX.Element {
  return <span css={styles.container}>{config.version}</span>
}
